"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RequestPersonalDemoVideo() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative py-16 md:py-24 bg-background overflow-hidden">
            {}
            <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      backgroundSize: "60px 60px"
    }} />

            <div className="container mx-auto px-4 max-w-2xl relative z-10">
                <div ref={ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`}>
                    <div className="text-center mb-10 md:mb-12">
                        <h2 className="text-4xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight mb-4 px-2">
                            Möchten Sie sehen, wie unsere KI-Rezeptionistin für Ihr Unternehmen arbeitet?
                        </h2>
                        <p className="text-base md:text-lg text-muted-foreground leading-relaxed px-2">Der letzte Schritt um ihren eigenen Virtuelle Asisstenen JETZT in Aktion zu sehen!</p>
                    </div>

                    <FormProvider className="glass-effect p-5 sm:p-6 md:p-8" formId="demo-request-form-homepage" sectionName="request-personal-demo-video" defaultValues={{
          company: "",
          name: "",
          email: "",
          phone: "",
          message: ""
        }} validationRules={{
          company: {
            required: true,
            minLength: 2,
            maxLength: 100
          },
          name: {
            required: true,
            minLength: 2,
            maxLength: 50
          },
          email: {
            required: true,
            pattern: "email"
          },
          phone: {
            required: true,
            minLength: 8,
            maxLength: 20
          },
          message: {
            required: false,
            maxLength: 500
          }
        }} submitText="Demo-Video anfordern" successMessage="Vielen Dank! Wir senden Ihnen Ihr persönliches Demo-Video in Kürze zu." errorMessage="Fehler beim Absenden. Bitte versuchen Sie es erneut.">
                        <DemoRequestForm />
                    </FormProvider>
                </div>
            </div>
        </section>;
}
function DemoRequestForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-primary-light border border-primary/20 rounded-md text-center">
                <p className="text-lg font-medium text-foreground leading-relaxed mb-4">{successMessage}</p>
                <Button onClick={resetForm} variant="outline" className="mt-2">
                    Weitere Anfrage senden
                </Button>
            </div>;
  }
  return <Form onSubmit={handleSubmit}>
            <div className="space-y-6">
                <FormField control={control} name="company" rules={{
        required: "Firmenname ist erforderlich",
        minLength: {
          value: 2,
          message: "Mindestens 2 Zeichen"
        },
        maxLength: {
          value: 100,
          message: "Maximal 100 Zeichen"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-base">Firmenname</FormLabel>
                            <FormControl>
                                <input type="text" placeholder="Ihr Firmenname" className="w-full min-h-[48px] px-4 py-3 text-base bg-background border border-border rounded-md text-foreground placeholder:text-muted-foreground transition-all duration-[var(--duration-fast)] ease-[var(--ease-out)] focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary hover:border-border-strong" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="name" rules={{
        required: "Name ist erforderlich",
        minLength: {
          value: 2,
          message: "Mindestens 2 Zeichen"
        },
        maxLength: {
          value: 50,
          message: "Maximal 50 Zeichen"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-base">Ihr Name</FormLabel>
                            <FormControl>
                                <input type="text" placeholder="Vor- und Nachname" className="w-full min-h-[48px] px-4 py-3 text-base bg-background border border-border rounded-md text-foreground placeholder:text-muted-foreground transition-all duration-[var(--duration-fast)] ease-[var(--ease-out)] focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary hover:border-border-strong" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="email" rules={{
        required: "E-Mail ist erforderlich",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Ungültige E-Mail-Adresse"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-base">E-Mail</FormLabel>
                            <FormControl>
                                <input type="email" placeholder="ihre@email.de" className="w-full min-h-[48px] px-4 py-3 text-base bg-background border border-border rounded-md text-foreground placeholder:text-muted-foreground transition-all duration-[var(--duration-fast)] ease-[var(--ease-out)] focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary hover:border-border-strong" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="phone" rules={{
        required: "Telefonnummer ist erforderlich",
        minLength: {
          value: 8,
          message: "Mindestens 8 Zeichen"
        },
        maxLength: {
          value: 20,
          message: "Maximal 20 Zeichen"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-base">Telefonnummer</FormLabel>
                            <FormControl>
                                <input type="tel" placeholder="+49 30 12345678" className="w-full min-h-[48px] px-4 py-3 text-base bg-background border border-border rounded-md text-foreground placeholder:text-muted-foreground transition-all duration-[var(--duration-fast)] ease-[var(--ease-out)] focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary hover:border-border-strong" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="message" rules={{
        maxLength: {
          value: 500,
          message: "Maximal 500 Zeichen"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-base">Nachricht (optional)</FormLabel>
                            <FormControl>
                                <textarea placeholder="Teilen Sie uns zusätzliche Details mit..." rows={4} className="w-full px-4 py-3 text-base bg-background border border-border rounded-md text-foreground placeholder:text-muted-foreground transition-all duration-[var(--duration-fast)] ease-[var(--ease-out)] focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary hover:border-border-strong resize-none" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                {submitError && <div className="p-4 bg-accent-light border border-accent/30 rounded-md">
                        <p className="text-sm text-foreground leading-relaxed">{submitError}</p>
                    </div>}

                <Button type="submit" disabled={isSubmitting} className="w-full min-h-[48px] text-base bg-primary text-foreground-primary font-semibold rounded-md shadow-soft transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50 disabled:cursor-not-allowed">
                    {isSubmitting ? <>
                            <Loader className="animate-spin mr-2 size-4" />
                            Wird gesendet...
                        </> : "Demo-Video anfordern"}
                </Button>
            </div>
        </Form>;
}